// import React from 'react';
// import ChartV5 from "../../../pages/apruebo-rechazo/apruebo-rechazov2/ChartV5";
import ChartApi from '../../../pages/apruebo-rechazo/ChartApi';

const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            {/* <ChartV5 /> */}
            <ChartApi customSize={2}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainCP;